import React from "react";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import {
    selectActiveSpan,
    selectClientAssetData,
    selectClientAssetDataDatasetStatus,
    selectClientAssetDataDatasetVersionDttm,
    setActiveSpanByName,
} from "./store/reducers/deviceLinkingAppStoreSlice";
import DatasetDerivedList from "./DatasetDerivedList";

type SpanListProps = {
    className?: string;
};

export default function SpanList(props: SpanListProps): JSX.Element {
    const dispatch = useAppDispatch();
    const dataset = useAppSelector(selectClientAssetData);
    const datasetStatus = useAppSelector(selectClientAssetDataDatasetStatus);
    const datasetVersion = useAppSelector(selectClientAssetDataDatasetVersionDttm);

    const activeObjectSpan = useAppSelector(selectActiveSpan);
    return (
        <DatasetDerivedList
            className={props.className}
            dataNotYetLoadedMessage="No data loaded. Select a Client & Project to continue"
            emptyListMessage="No spans in dataset"
            errorMessage="Error loading data"
            datasetStatus={datasetStatus}
            datasetType={dataset?.meta?.dataset_type || ""}
            datasetVersion={datasetVersion || ""}
            selectObject={(span) => span && dispatch(setActiveSpanByName(span.span_name))}
            isActiveObject={(obj) => activeObjectSpan?.span_name === obj.span_name}
            objectList={dataset?.data.spans || []}
            extractObjectKey={(span) => span.span_name}
            extractObjectLabel={(span) => span.span_name}
        />
    );
}
